/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Rent Report bizos
 */

import { Bizo, autoclass } from './base'
import type {
  RawRentReport,
  RawRentReportRow,
  RentReportRow as RentReportRowType,
  RentReport as RentReportType,
} from './rentReport.types'

export type RentReport = RentReportType

export const RentReportRow: typeof RentReportRowType = autoclass<
  RentReportRowType,
  RawRentReportRow
>('RentReportRow', class RentReportRow extends Bizo<RentReportRow, RawRentReportRow> {}, {
  city: 'city',
  monthChange1: 'month_change_1',
  monthChange2: 'month_change_2',
  price1: 'price_1',
  price2: 'price_2',
  ranking: 'ranking',
  rankingChange: 'ranking_change',
  url: (rentReportRow: RentReportRow) =>
    rentReportRow._data.url ||
    rentReportRow.city.replace(/ +/g, '-').replace(/[,.]/g, '').toLowerCase(),
  yearChange1: 'year_change_1',
  yearChange2: 'year_change_2',
})

export type RentReportRow = RentReportRowType

export const RentReport: typeof RentReportType = autoclass<RentReport, RawRentReport>(
  'RentReport',
  class RentHistoryDetail extends Bizo<RentReport, RawRentReport> {},
  {
    css: 'css',
    html: 'html',
    fullData: {
      isArray: true,
      name: 'full_data',
      type: RentReportRow,
    },
  }
)
